"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseResourceName = void 0;
function parseResourceName(value) {
    const regex = /^(?<short>(\.\/)?\w+)$|(?<full>(?<namespace>\w+)\/(?<package>\w+)\/(?<name>\w+)(@(?<version>(.+))){0,1})?$/;
    // parse action call
    const match = regex.exec(value === null || value === void 0 ? void 0 : value.trim());
    if (!match || !match.groups || (!match.groups.short && !match.groups.namespace)) {
        throw `Invalid syntax: ${value}`;
    }
    if (match.groups.short) {
        return match.groups.short;
    }
    else {
        return {
            namespace: match.groups.namespace,
            package: match.groups.package,
            name: match.groups.name,
            version: match.groups.version,
        };
    }
}
exports.parseResourceName = parseResourceName;
//# sourceMappingURL=parseResourceName.js.map